import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { LayoutContainer } from "../components";
import { Footer } from "../components/Footer";
import { Navigation } from "../components/Nav";
import { ThemeContext } from "../components/context";

export const Layout = () => {
  const { rooTheme } = useContext(ThemeContext);

  return (
    <LayoutContainer rooTheme={rooTheme}>
      <Navigation />

      <main>
        <Outlet />
      </main>
      <footer>
        <Footer />
      </footer>
    </LayoutContainer>
  );
};
